/* global axios */
import ApiClient from './ApiClient';

const buildParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== ''
    )
  ).toString();

class SocialCommentsAPI extends ApiClient {
  constructor() {
    super('social_comments', { accountScoped: true });
  }

  get(params = {}) {
    const { inboxId, socialPostId, state, page = 1 } = params;
    const requestURL = `${this.url}?${buildParams({
      inbox_id: inboxId,
      social_post_id: socialPostId,
      state,
      page,
    })}`;
    return axios.get(requestURL);
  }

  reply(id, message) {
    return axios.post(`${this.url}/${id}/reply`, { message });
  }

  privateReply(id, message) {
    return axios.post(`${this.url}/${id}/private_reply`, { message });
  }

  hide(id) {
    return axios.post(`${this.url}/${id}/hide`);
  }

  unhide(id) {
    return axios.post(`${this.url}/${id}/unhide`);
  }

  like(id) {
    return axios.post(`${this.url}/${id}/like`);
  }

  unlike(id) {
    return axios.post(`${this.url}/${id}/unlike`);
  }

  handle(id) {
    return axios.post(`${this.url}/${id}/handle`);
  }
}

export default new SocialCommentsAPI();
